import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { WaypointResult } from '~/generated/api-clients-generated'

export default class OtherPlansPushTypeNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const postGuidedRecPushType = flag<string>('post-guided-rec-push-type').value

    switch (postGuidedRecPushType) {
      case 'call':
        return this._destinations.get(WaypointResult.OtherPlansPushType_Call) ?? null
      case 'chat':
        return this._destinations.get(WaypointResult.OtherPlansPushType_Chat) ?? null
      case 'none':
        return this._destinations.get(WaypointResult.ExploreOptions_JustBrowse) ?? null
      default:
        return this._destinations.get(WaypointResult.ExploreOptions_JustBrowse) ?? null
    }
  }
}
